module.exports = __webpack_public_path__ + "img/project-29.cf997374.png";